import {
  ButtonERP,
  ColumnsGroup,
  DataTablePrimeReact,
  Dialog,
  PaginationERP,
} from "@finanedi.es/storybook"
import { GetPrestamoByFiltersDtoProps } from "api/DTOs/GetPrestamoByFiltersDto"
import {
  GetPrestamosByFiltersParamsProps,
  getPrestamoByFilters,
  getPrestamosExportarExcel,
  prestamoByFiltersCall,
} from "api/Prestamos.service"
import { TotalesGetPrestamoByFiltersDtoProps } from "api/Schemas/TotalesGetPrestamoByFiltersDto"
import { TIPO_PRESTAMO, TipoPrestamoType } from "api/Types/TipoPrestamo"
import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import { SortingCriteria } from "api/interfaces/SortingCriteria"
import ActionToast from "common/components/ActionToast"
import Modal from "common/components/Modal/Modal"
import { handleDirectDownloadExcel } from "common/context/DownloadFileProvider"
import ContabilidadService from "common/services/ContabilidadService"
import TesoreriaService from "common/services/TesoreriaService"
import { ESTADO_TIPO_PRESTAMOS } from "common/utils/constants"
import { OpenModalfromDirectAccess, requestHandler } from "common/utils/utils"
import { DATE_YYYY_MM_DD } from "constants/formatoFechas"
import { PAGINATION_STYLES } from "constants/primereactStyles"
import { format } from "date-fns"
import NewRemesaForm from "features/Tesoreria/components/NewRemesaForm"
import {
  getIdsFromDocumentos,
  getTotals,
} from "features/Tesoreria/pages/Cartera/constants"
import { fetchUsersByFilter } from "features/User/redux/slices/userSlice"
import { useDispatch } from "hooks/useDispatch"
import { useFilterMenu } from "hooks/useFilterMenu"
import { DataTableRowClickEventParams } from "primereact/datatable"
import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"
import { frontendCurrency } from "utils/formatCurrency"
import {
  DateRangeModalFechas,
  ModalFechas,
} from "../LibroDiario/components/Modales/ModalFechas"
import { FilterMenu } from "./components/FilterMenu"
import NewPrestamoForm from "./components/NewPrestamoForm"
import TablePrestamos from "./components/Table/TablePrestamos"
import { TABLE_PRESTAMO_COLUMNS } from "./components/Table/TablePrestamosColumns"
import { transformDataFromRemesasToRemesasPrestamos } from "./constants"
import {
  PRESTAMO_DEFAULT_FILTERS,
  PrestamoFiltersProps,
} from "./pages/PrestamoDetail/prestamoFilters"
import "./style.scss"

const Prestamos = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const initialExportExcel = {
    min: undefined,
    max: undefined,
  }
  const { activeCompany } = useUsuarioEmpresaActiva()
  const location = useLocation()
  const [toastValues, setToastValues] = useState({ total: 0, quantity: 0 })
  const [isAdeudo, setIsAdeudo] = useState(false)
  const [documentSelected, setDocumentSelected] = useState<
    Array<GetPrestamoByFiltersDtoProps>
  >([])
  const [showExportDatesModal, setShowExportDatesModal] = useState(false)
  const [date, setDate] = useState<
    DateRangeModalFechas | { min: undefined; max: undefined }
  >(initialExportExcel)
  const [showNewRemesa, setShowNewRemesa] = useState({
    data: null,
    status: false,
  })

  const [showCreateModal, setShowCreateModal] = useState({
    data: null,
    status: false,
  })

  const [prestamosFilters, setPrestamosFilters] =
    useState<PrestamoFiltersProps>(
      JSON.parse(
        sessionStorage.getItem("filtroPrestamo") ??
          JSON.stringify(PRESTAMO_DEFAULT_FILTERS)
      )
    )

  const [sortingCriteria, setSortingCriteria] = useState<SortingCriteria>({
    sort: undefined,
    property: undefined,
  })
  const [pagination, setPagination] = useState({
    itemsPerPage: 100,
    skipCount: 0,
  })
  const [sortField, setSortField] = useState<string | undefined>(undefined)
  const [sortOrder, setSortOrder] = useState<1 | 0 | -1 | null | undefined>(0)
  const dtRef = useRef<DataTablePrimeReact<
    GetPrestamoByFiltersDtoProps[]
  > | null>(null)
  const handleResetPagination = () => {
    dtRef.current && dtRef.current?.resetScroll()
    setPagination({
      itemsPerPage: pagination.itemsPerPage,
      skipCount: 0,
    })
  }
  const onSort = ({
    sortField,
    sortOrder,
  }: {
    sortField: string | undefined
    sortOrder: 1 | 0 | -1 | null | undefined
  }) => {
    setSortingCriteria({
      property: sortField ?? undefined,
      sort: sortOrder === 1 ? "ASC" : sortOrder === -1 ? "DESC" : undefined,
    })
    setSortField(sortField)
    setSortOrder(sortOrder)
    handleResetPagination()
  }

  const handlePrestamosFiltersInLocal = (
    value: Partial<PrestamoFiltersProps>
  ) => {
    const newValuePrestamosFilter = {
      ...prestamosFilters,
      ...value,
    }
    setPrestamosFilters(newValuePrestamosFilter)
  }

  const [tabSelected, setTabSelected] = useState<TipoPrestamoType>(
    prestamosFilters.TAB_SELECTED ?? TIPO_PRESTAMO.CONCEDIDO
  )

  const exportToExcel = async () => {
    const params: Record<string, string> = {}
    if (date?.min) params.FechaLowerLimit = format(date.min, DATE_YYYY_MM_DD)
    if (date?.max) params.FechaUpperLimit = format(date.max, DATE_YYYY_MM_DD)
    const { data } = await getPrestamosExportarExcel(params)
    handleDirectDownloadExcel(data, `${t("exportarXlxs.prestamos")}.xlsx`)
  }

  useEffect(() => {
    dispatch(fetchUsersByFilter())
  }, [dispatch])

  useEffect(() => {
    const newSave = {
      ...prestamosFilters,
      PAGINACION: pagination,
      SORTING_CRITERIA: sortingCriteria,
    }
    sessionStorage.setItem("filtroPrestamo", JSON.stringify(newSave))
  }, [prestamosFilters, pagination, sortingCriteria, activeCompany])

  const fetchPrestamos = useCallback(() => {
    return async (queryParams: GetPrestamosByFiltersParamsProps) => {
      if (!queryParams.TipoPrestamo) {
        return
      }
      prestamoByFiltersCall?.cancel()
      const querys = {
        ...queryParams,
      }

      return getPrestamoByFilters(querys)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onRowClick = ({ data }: DataTableRowClickEventParams) => {
    const { id } = data
    history.push(`${ROUTES.PRESTAMOS}/${id}`)
  }
  const {
    items,
    isLoading,
    totalCount,
    totales,
    setServiceQuery,
    fetchTableData,
  } = useFilterMenu<TotalesGetPrestamoByFiltersDtoProps>({
    serviceCall: fetchPrestamos,
  })
  const handleOpenCreateModal = useCallback((status: $TSMigrationFixMe) => {
    setShowCreateModal({
      data: null,
      status,
    })
    setDocumentSelected([])
  }, [])

  useEffect(() => {
    OpenModalfromDirectAccess(location, "PRESTAMO", handleOpenCreateModal)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleRedirectToList = async () => {
    history.push(ROUTES.PRESTAMOS)
  }

  const clearRemesaSelection = useCallback(() => {
    setDocumentSelected([])
    setToastValues({ total: 0, quantity: 0 })
    history.replace()
  }, [history])

  const onSuccessCreate = async () => {
    fetchTableData()
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 2.
    handleOpenCreateModal(null, false)
  }

  const handleCreate = async (values: $TSMigrationFixMe) => {
    requestHandler(
      values,
      ContabilidadService.createPrestamo,
      onSuccessCreate,
      `${t("prestamos.msg.createLoanExit")}`,
      null,
      null,
      null
    )
  }

  const handleOpenNewRemesa = (
    isRemesaAdeudo: $TSMigrationFixMe,
    isOpen: $TSMigrationFixMe
  ) => {
    setIsAdeudo(isRemesaAdeudo)
    const totalValue = getTotals(documentSelected, "importe")
    const documentIds = getIdsFromDocumentos(documentSelected)
    setShowNewRemesa({
      // @ts-expect-error TS(2322): Type '{ total: $TSFixMe; facturasIds: $TSFixMe; operationTyp...
      data: {
        total: totalValue,
        facturasIds: documentIds,
        operationType: isRemesaAdeudo
          ? tabSelected
          : ESTADO_TIPO_PRESTAMOS(t)[tabSelected].reversedValue,
      },
      status: isOpen,
    })
  }

  const handleHideToast = () => {
    setDocumentSelected([])
    // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'number'.
    setToastValues({ ...toastValues, quantity: null })
  }

  const onSuccessCreateRemesa = async () => {
    handleRedirectToList()
  }
  const onPostCreate = () => {
    clearRemesaSelection()
  }

  const handleCreateRemesa = async (values: $TSMigrationFixMe) => {
    const transformedValues = transformDataFromRemesasToRemesasPrestamos(
      values,
      isAdeudo
    )
    requestHandler(
      transformedValues,
      TesoreriaService.createRemesaPrestamo,
      onSuccessCreateRemesa,
      `${t("prestamos.msg.createRemittanceExit")}`,
      null,
      null,
      onPostCreate
    )
    setShowNewRemesa({
      // @ts-expect-error TS(2322): Type '{}' is not assignable to type 'null'.
      data: {},
      status: false,
    })
  }

  const onRenderContent = useMemo(() => {
    return (
      <div className='tw-flex tw-justify-center md:tw-justify-start'>
        <span className='tw-font-medium'>
          {t("prestamos.form.remesar.selectedLabel")} {documentSelected?.length}
        </span>
      </div>
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentSelected?.length])

  return (
    <div className='tw-flex tw-flex-col tw-order-2 tw-z-10 tw-relative tw-w-full tw-max-h-screen tw-h-full tw-max-w-screen tw-bg-gray tw-overflow-x-hidden tw-overflow-y-hidden'>
      <FilterMenu
        serviceQuery={setServiceQuery}
        sortingCriteria={sortingCriteria}
        maxResultCount={pagination.itemsPerPage}
        skipCount={pagination.skipCount}
        resetPagination={handleResetPagination}
        tabSelected={tabSelected}
        setTabSelected={setTabSelected}
        createNew={() => handleOpenCreateModal(true)}
        prestamosFilters={prestamosFilters}
        handlePrestamosFiltersInLocal={handlePrestamosFiltersInLocal}
        exportToExcel={() => setShowExportDatesModal(true)}
      />
      <div className='tw-flex tw-flex-col tw-h-[calc(100%-96px)] tw-relative'>
        <div className='tw-h-[calc(100%-60px)] tw-h-min-0'>
          <TablePrestamos
            refTable={dtRef}
            value={items}
            loading={isLoading}
            columns={TABLE_PRESTAMO_COLUMNS(t)}
            onSort={onSort}
            sortField={sortField}
            sortOrder={sortOrder}
            onRowClick={onRowClick}
            selection={documentSelected}
            onSelectionChange={({
              value,
            }: {
              value: GetPrestamoByFiltersDtoProps[]
            }) => {
              setDocumentSelected(value)
              setToastValues({ ...toastValues, quantity: value?.length })
            }}
            footer={ColumnsGroup({
              items: [
                {
                  value: String(t("prestamos.tab.footerTotals")),
                  colSpan: 8,
                },
                {
                  value: totales?.importeAmortizacion
                    ? frontendCurrency(totales.importeAmortizacion)
                    : "-",
                },
                {
                  value: totales?.importe
                    ? frontendCurrency(totales.importe)
                    : "-",
                },
                {
                  value: totales?.totalAmortizado
                    ? frontendCurrency(totales.totalAmortizado)
                    : "-",
                },
                {
                  value: totales?.importePendiente
                    ? frontendCurrency(totales.importePendiente)
                    : "-",
                },
              ],
            })}
          />
        </div>
        <PaginationERP
          className={PAGINATION_STYLES}
          totalRecords={totalCount}
          first={pagination.skipCount}
          rows={pagination.itemsPerPage}
          resetScroll={() => {
            dtRef.current && dtRef.current?.resetScroll()
          }}
          setPagination={setPagination}
          optionDropdown={[10, 20, 50, 100]}
          texts={{
            textRowsPerPageDropdown: `${t("pagination.textRowsPag")}`,
            textCurrentPageReport: `${t("pagination.from")}`,
          }}
        />
      </div>

      <Dialog
        header={
          // @ts-expect-error TS(2339): Property 'id' does not exist on type '{ data: null...
          showCreateModal?.id
            ? `${t("prestamos.form.modal.headerEdit")}`
            : `${t("prestamos.form.modal.headerNew")}`
        }
        visible={showCreateModal.status}
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 2.
        onHide={() => handleOpenCreateModal(null, false)}
        maskClassName='!tw-p-6'
        className='!tw-mt-6 !tw-w-180'
        baseZIndex={30}
        draggable
      >
        <NewPrestamoForm
          // @ts-expect-error TS(2322): Type '{ hideModal: () => void; dispatch: Dispatch<...
          hideModal={() => handleOpenCreateModal(null, false)}
          dispatch={dispatch}
          // @ts-expect-error TS(2554): Expected 1 arguments, but got 2.
          onHide={() => handleOpenCreateModal(null, false)}
          handleSubmitPrestamo={handleCreate}
          tipoPrestamo={tabSelected}
          t={t}
          // @ts-expect-error TS(2339): Property 'id' does not exist on type '{ data: null...
          newPrestamo={!showCreateModal?.id}
        />
      </Dialog>

      <ActionToast
        show={Boolean(documentSelected?.length)}
        onHide={handleHideToast}
        content={onRenderContent}
        customButtons={
          <div className='tw-flex tw-items-center tw-gap-2'>
            <ButtonERP
              customize={{
                type: "secondary",
                size: "md",
              }}
              onClick={() => handleOpenNewRemesa(false, true)}
              label={`${t("prestamos.form.remesar.remittanceLabel")}`}
            />
            <ButtonERP
              customize={{
                type: "primary",
                size: "md",
              }}
              onClick={() => handleOpenNewRemesa(true, true)}
              label={`${t("prestamos.form.remesar.remitDebitsLabel")}`}
            />
          </div>
        }
      />
      <Modal
        header={t("prestamos.form.remesar.newRemittance")}
        visible={showNewRemesa.status}
        onHide={() => handleOpenNewRemesa(null, false)}
        size='small'
        maskClassName='!tw-z-20'
      >
        <NewRemesaForm
          hideModal={() => handleOpenNewRemesa(null, false)}
          onHide={() => handleOpenNewRemesa(null, false)}
          handleCreate={handleCreateRemesa}
          // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'NewRemesaFo...
          data={showNewRemesa.data}
          t={t}
        />
      </Modal>
      <ModalFechas
        isOpen={showExportDatesModal}
        date={date}
        setDate={setDate}
        onCancel={() => {
          setShowExportDatesModal(false)
          setDate(initialExportExcel)
        }}
        onConfirm={exportToExcel}
        text={`${t("diario.exportModal.dateRange")}`}
      />
    </div>
  )
}

export default Prestamos
